import React, { useState } from 'react';
import { BellIcon, SearchIcon, ChevronDown, LogOut, Settings, Menu } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

function TopBar({ onMenuToggle }) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('[TopBar] Logout error:', error);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 h-16 bg-gradient-to-r from-blue-50 to-white border-b border-gray-200 z-30 shadow-sm">
      <div className="flex items-center justify-between h-full px-4 
        md:ml-64 
        relative">
        {/* Mobile Menu and Title */}
        <div className="flex items-center space-x-4">
          {/* Menu button for mobile */}
          <button 
            className="md:hidden mr-2"
            onClick={onMenuToggle}
          >
            <Menu className="h-6 w-6 text-gray-700" />
          </button>
          
          <span className="text-xl font-semibold text-gray-900 truncate max-w-[200px]">
            GoGet Admin
          </span>
        </div>

        {/* Search - Hidden on mobile by default */}
        <div className="hidden md:block flex-1 max-w-2xl mx-4">
          <div className="relative">
            <input
              type="text"
              placeholder="Search..."
              className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <SearchIcon className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
          </div>
        </div>

        {/* Mobile Search Toggle */}
        <div className="md:hidden flex items-center space-x-2">
          <button 
            onClick={() => setShowMobileSearch(!showMobileSearch)}
            className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg"
          >
            <SearchIcon className="h-6 w-6" />
          </button>
        </div>

        {/* Right side actions */}
        <div className="flex items-center space-x-4">
          <button className="relative p-2 text-gray-600 hover:bg-gray-100 rounded-lg">
            <BellIcon className="h-6 w-6" />
            <span className="absolute top-1 right-1 h-2 w-2 bg-red-500 rounded-full"></span>
          </button>
          
          {/* User Menu */}
          <div className="relative">
            <button 
              onClick={() => setShowDropdown(!showDropdown)}
              className="flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <div className="w-8 h-8 rounded-full bg-gray-300"></div>
              <div className="hidden md:flex items-center">
                <span className="text-sm font-medium text-gray-700 mr-2">
                  {user?.name || 'Admin User'}
                </span>
                <ChevronDown className="h-4 w-4 text-gray-500" />
              </div>
            </button>

            {/* Dropdown Menu */}
            {showDropdown && (
              <div className="absolute right-0 mt-2 w-64 md:w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5">
                <div className="px-4 py-2 border-b border-gray-100 md:block">
                  <p className="text-sm font-medium text-gray-900">{user?.email}</p>
                  <p className="text-xs text-gray-500 capitalize">{user?.role}</p>
                </div>
                
                <button 
                  onClick={() => {
                    setShowDropdown(false);
                    navigate('/settings');
                  }}
                  className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <Settings className="h-4 w-4 mr-3" />
                  Settings
                </button>

                <button 
                  onClick={() => {
                    setShowDropdown(false);
                    handleLogout();
                  }}
                  className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50"
                >
                  <LogOut className="h-4 w-4 mr-3" />
                  Sign out
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Mobile Search Dropdown */}
      {showMobileSearch && (
        <div className="md:hidden absolute top-full left-0 right-0 p-4 bg-white shadow-md">
          <div className="relative">
            <input
              type="text"
              placeholder="Search..."
              className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <SearchIcon className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
          </div>
        </div>
      )}
    </header>
  );
}

export default TopBar;